<template>
  <div class="flow-design-form">
    <!-- 工具条 -->
    <div class="flow-toolbar">
      <a-input v-model="form.flowName" placeholder="请输入流程名称" style="width: 200px;" />
      <a-select v-model="form.billType" placeholder="选择单据类型" :disabled="!!form.id" style="width: 200px;">
        <a-select-option v-for="(n, k) in billTypes" :key="k" :value="k">{{ n }}</a-select-option>
      </a-select>
      <a-button @click="undo">撤销</a-button>
      <a-button @click="redo">重做</a-button>
      <a-button size="small" @click="zoomIn">放大</a-button>
      <a-button size="small" @click="zoomOut">缩小</a-button>
      <a-button size="small" @click="fitView">适应</a-button>
      <a-button size="small" type="danger" @click="deleteSelected">删除选中</a-button>
      <a-button icon="code" @click="showJsonModal">模板JSON</a-button>
      <a-button type="primary" @click="handleSave">保存</a-button>
      <a-button @click="handleBack">返回</a-button>
      <span v-if="isDefaultFlow" style="color: #fa8c16; margin-left: 12px;">当前为系统默认流程，保存将生成你自己的方案</span>
      <span v-if="billTypeEmpty" style="color: #f5222d; margin-left: 12px;">请先在系统配置→多级审核中勾选需审批的单据</span>
    </div>

    <div class="flow-designer">
      <div class="node-panel">
        <div class="panel-title">节点类型</div>
        <div class="node-item" v-for="n in nodeTypes" :key="n.type"
             @mousedown="startDrag(n.type, $event)" @click="addNode(n.type)">{{ n.label }}</div>
      </div>
      <div ref="flowContainer" class="flow-canvas"></div>
      <div class="prop-panel">
        <div class="panel-title">属性</div>
        <div v-if="!currentEdit" class="panel-tip">点击节点或连线进行编辑</div>

        <div v-if="currentEdit && currentEdit.kind === 'node'">
          <a-form layout="vertical">
            <a-form-item label="节点名称">
              <a-input v-model="editForm.text" />
            </a-form-item>
            <template v-if="currentEdit.bizType === 'condition'">
              <a-form-item label="分支条件">
                <div v-if="conditionEdges.length === 0" style="color: rgba(0,0,0,0.45);">暂无出边，请先从此节点连线到下游节点</div>
                <div v-for="(e, i) in conditionEdges" :key="i" style="margin-bottom: 4px;">分支 {{ i + 1 }}：{{ e.text }}</div>
                <a-alert type="info" show-icon style="margin-top: 8px;"
                  message="分支条件在连线上配置"
                  description="请点击某条连线，在右侧面板设置「字段 + 操作符 + 值」，或切换为默认分支。" />
              </a-form-item>
            </template>
            <template v-if="currentEdit.bizType === 'approval' || currentEdit.bizType === 'cc'">
              <a-form-item label="审批人来源">
                <a-select v-model="editForm.assigneeType">
                  <a-select-option value="fixed_user">固定用户</a-select-option>
                  <a-select-option value="role">角色</a-select-option>
                  <a-select-option value="dept_leader">部门上级</a-select-option>
                  <a-select-option value="starter_choose">发起人指定</a-select-option>
                  <a-select-option value="field_var">字段变量</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="审批人" v-if="editForm.assigneeType === 'fixed_user'">
                <a-select mode="multiple" v-model="assigneeIdArr" placeholder="请选择用户" showSearch optionFilterProp="children">
                  <a-select-option v-for="u in userList" :key="u.id" :value="u.id">{{ u.username || u.loginName }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="角色" v-if="editForm.assigneeType === 'role'">
                <a-select v-model="editForm.roleId" placeholder="请选择角色" showSearch optionFilterProp="children">
                  <a-select-option v-for="r in roleList" :key="r.id" :value="r.id">{{ r.name }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="字段名" v-if="editForm.assigneeType === 'field_var'">
                <a-input v-model="editForm.assigneeIds" placeholder="如 creator，对应单据字段" />
              </a-form-item>
              <a-form-item label="审批方式" v-if="currentEdit.bizType === 'approval'">
                <a-select v-model="editForm.approveType">
                  <a-select-option value="or_sign">或签（任一通过）</a-select-option>
                  <a-select-option value="sign">会签（全部通过）</a-select-option>
                </a-select>
              </a-form-item>
            </template>
          </a-form>
          <a-button type="primary" block @click="applyNode">应用</a-button>
          <a-button type="danger" block style="margin-top: 8px;" @click="deleteCurrent">删除节点</a-button>
        </div>

        <div v-if="currentEdit && currentEdit.kind === 'edge'">
          <a-form layout="vertical">
            <a-form-item label="分支类型">
              <a-radio-group v-model="editForm.isDefaultBranch">
                <a-radio :value="false">条件分支</a-radio>
                <a-radio :value="true">默认分支</a-radio>
              </a-radio-group>
            </a-form-item>
            <template v-if="!editForm.isDefaultBranch">
              <a-form-item label="条件关系">
                <a-radio-group v-model="editForm.conditionOp">
                  <a-radio value="AND">满足全部</a-radio>
                  <a-radio value="OR">满足任一</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item v-for="(c, idx) in editForm.conditionList" :key="idx" :label="'条件 ' + (idx + 1)">
                <a-row :gutter="4">
                  <a-col :span="9">
                    <a-select v-model="c.field" placeholder="字段">
                      <a-select-option v-for="f in conditionFields" :key="f.value" :value="f.value">{{ f.label }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="7">
                    <a-select v-model="c.operator" placeholder="操作符">
                      <a-select-option value=">">大于</a-select-option>
                      <a-select-option value=">=">大于等于</a-select-option>
                      <a-select-option value="<">小于</a-select-option>
                      <a-select-option value="<=">小于等于</a-select-option>
                      <a-select-option value="==">等于</a-select-option>
                      <a-select-option value="!=">不等于</a-select-option>
                      <a-select-option value="contains">包含</a-select-option>
                      <a-select-option value="in">属于(逗号分隔)</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="6">
                    <a-input v-model="c.value" placeholder="值" />
                  </a-col>
                  <a-col :span="2" style="text-align: center;">
                    <a @click="removeCondition(idx)">删</a>
                  </a-col>
                </a-row>
              </a-form-item>
              <a-button type="dashed" block @click="addCondition">+ 增加条件</a-button>
            </template>
          </a-form>
          <a-button type="primary" block @click="applyEdge">应用</a-button>
          <a-button type="danger" block style="margin-top: 8px;" @click="deleteCurrent">删除连线</a-button>
        </div>
      </div>
    </div>

    <a-modal :visible="jsonModalVisible" title="流程JSON" width="700px" :footer="null" @cancel="jsonModalVisible = false">
      <a-button size="small" @click="formatJson">格式化</a-button>
      <a-button size="small" @click="compressJson">压缩</a-button>
      <a-button size="small" @click="copyJson">复制</a-button>
      <a-textarea v-model="jsonText" :rows="18" style="margin-top: 8px;" />
      <div style="margin-top: 12px; text-align: right;">
        <a-button @click="jsonModalVisible = false">取消</a-button>
        <a-button type="primary" style="margin-left: 8px;" @click="applyJson">应用</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import LogicFlow, { CircleNode, CircleNodeModel } from '@logicflow/core'
  import '@logicflow/core/dist/style/index.css'
  import { RectResize, DiamondResize, SelectionSelect } from '@logicflow/extension'
  import '@logicflow/extension/lib/style/index.css'
  import { flowDefineSave, flowDefineGetByBillType, flowDefineGetById } from './api'
  import { getCurrentSystemConfig } from '@/api/api'
  import { getAction } from '@/api/manage'

  LogicFlow.use(SelectionSelect)

  const BILL_TYPE_NAMES = {
    'CGRK': '采购入库', 'CGTH': '采购退货', 'XSCK': '销售出库', 'XSTH': '销售退货',
    'LSCK': '零售出库', 'LSTH': '零售退货', 'QTRK': '其它入库', 'QTCK': '其它出库',
    'DBCK': '调拨出库', 'ZZD': '组装单', 'CXD': '拆卸单',
    'QGD': '请购单', 'CGDD': '采购订单', 'XSDD': '销售订单',
    'PDLR': '盘点录入', 'PDFP': '盘点复盘', 'NSLD': '资产申领', 'NCKD': '资产出库',
    'SR': '收入单', 'ZC': '支出单', 'SK': '收款单', 'FK': '付款单', 'ZZ': '转账单', 'SYF': '收预付款', 'PZ': '凭证',
    'ZG': '资产转固单', 'ZCBD': '资产变动单', 'ZCWX': '资产维修单', 'ZCDB': '资产调拨单',
    'ZCJT': '折旧计提单', 'ZCCZ': '资产处置单', 'ZCBF': '资产报废单', 'FTDD': '发图订单'
  }

  const DEFAULT_TEXT = { start: '发起人', end: '结束', approval: '审批节点', cc: '抄送节点', condition: '条件节点' }

  // 开始节点（绿色圆形）
  class StartModel extends CircleNodeModel {
    getNodeStyle () {
      const style = super.getNodeStyle()
      style.fill = '#f6ffed'
      style.stroke = '#52c41a'
      style.strokeWidth = 1
      return style
    }
  }
  class StartView extends CircleNode {}

  // 结束节点（红色圆形）
  class EndModel extends CircleNodeModel {
    getNodeStyle () {
      const style = super.getNodeStyle()
      style.fill = '#fff1f0'
      style.stroke = '#f5222d'
      style.strokeWidth = 1
      return style
    }
  }
  class EndView extends CircleNode {}

  // 审批节点（蓝色矩形，可缩放）
  class ApprovalModel extends RectResize.model {
    getNodeStyle () {
      const style = super.getNodeStyle()
      style.fill = '#e6f7ff'
      style.stroke = '#1890ff'
      style.strokeWidth = 1
      return style
    }
  }
  class ApprovalView extends RectResize.view {}

  // 抄送节点（紫色矩形，可缩放）
  class CcModel extends RectResize.model {
    getNodeStyle () {
      const style = super.getNodeStyle()
      style.fill = '#f9f0ff'
      style.stroke = '#722ed1'
      style.strokeWidth = 1
      return style
    }
  }
  class CcView extends RectResize.view {}

  // 条件节点（橙色菱形，可缩放）
  class ConditionModel extends DiamondResize.model {
    getNodeStyle () {
      const style = super.getNodeStyle()
      style.fill = '#fff7e6'
      style.stroke = '#fa8c16'
      style.strokeWidth = 1
      return style
    }
  }
  class ConditionView extends DiamondResize.view {}

  export default {
    name: 'FlowDesignForm',
    data () {
      return {
        saving: false,
        billTypes: {},
        billTypeEmpty: false,
        isDefaultFlow: false,
        form: { id: null, flowName: '', billType: '', flowCode: '', formJson: '' },
        nodeTypes: [
          { type: 'start', label: '发起人' },
          { type: 'approval', label: '审批节点' },
          { type: 'condition', label: '条件节点' },
          { type: 'cc', label: '抄送节点' },
          { type: 'end', label: '结束' }
        ],
        userList: [],
        roleList: [],
        currentEdit: null,
        editForm: { text: '', assigneeType: 'fixed_user', assigneeIds: '', roleId: undefined, approveType: 'or_sign', conditionOp: 'AND', isDefaultBranch: false, conditionList: [] },
        conditionFields: [
          { value: 'totalPrice', label: '合计金额' },
          { value: 'changeAmount', label: '变动金额(收/付款)' },
          { value: 'discountMoney', label: '优惠金额' },
          { value: 'discountLastMoney', label: '优惠后金额' },
          { value: 'otherMoney', label: '其它费用' },
          { value: 'deposit', label: '订金' },
          { value: 'type', label: '单据大类/类型' },
          { value: 'subType', label: '单据子类' },
          { value: 'creator', label: '操作员' }
        ],
        assigneeIdArr: [],
        conditionEdges: [],
        jsonModalVisible: false,
        jsonText: '',
        lf: null
      }
    },
    mounted () {
      this._onResize = () => { if (this.lf) this.lf.resize() }
      window.addEventListener('resize', this._onResize)
    },
    beforeDestroy () {
      if (this._onResize) {
        window.removeEventListener('resize', this._onResize)
      }
    },
    methods: {
      open (record, billType) {
        this.currentEdit = null
        this.isDefaultFlow = false
        this.loadBillTypes()
        this.loadUsers()
        this.loadRoles()
        if (record && record.id) {
          this.form = { id: record.id, flowName: record.flowName, billType: record.billType, flowCode: record.flowCode, formJson: record.formJson || '' }
          flowDefineGetById({ id: record.id }).then((res) => {
            if (res && res.code === 200 && res.data && res.data.exist) {
              const def = res.data.flowDefine
              this.form.formJson = def.formJson
              this.form.flowName = def.flowName
              this.form.billType = def.billType
              this.form.flowCode = def.flowCode
            }
            this.scheduleInit()
          }).catch(() => {
            this.scheduleInit()
          })
        } else {
          this.form = { id: null, flowName: '', billType: billType || '', flowCode: '', formJson: '' }
          if (billType) {
            flowDefineGetByBillType({ billType: billType }).then((res) => {
              if (res && res.code === 200 && res.data && res.data.exist) {
                const def = res.data.flowDefine
                this.form.formJson = def.formJson
                this.form.flowName = def.flowName
                this.isDefaultFlow = String(def.tenantId) === '0'
              }
              this.scheduleInit()
            })
          } else {
            this.scheduleInit()
          }
        }
      },
      loadBillTypes () {
        getCurrentSystemConfig().then((res) => {
          if (res && res.code === 200 && res.data) {
            const mt = res.data.multiBillType || ''
            const prefixes = mt.split(',').filter(p => p && p.trim())
            const map = {}
            prefixes.forEach(p => {
              const key = p.trim()
              map[key] = BILL_TYPE_NAMES[key] || key
            })
            this.billTypes = map
            this.billTypeEmpty = prefixes.length === 0
          } else {
            this.billTypes = {}
            this.billTypeEmpty = true
          }
        }).catch(() => {
          this.billTypes = {}
          this.billTypeEmpty = true
        })
      },
      loadUsers () {
        getAction('/user/list', { currentPage: 1, pageSize: 500 }).then((res) => {
          if (res && res.code === 200 && res.data && res.data.rows) {
            this.userList = res.data.rows
          }
        })
      },
      loadRoles () {
        getAction('/role/list', { currentPage: 1, pageSize: 500 }).then((res) => {
          if (res && res.code === 200 && res.data && res.data.rows) {
            this.roleList = res.data.rows
          }
        })
      },
      scheduleInit () {
        if (this.lf) {
          this.lf.clearData()
          this.renderGraph()
          return
        }
        const el = this.$refs.flowContainer
        if (el && el.clientWidth > 0 && el.clientHeight > 0) {
          this.initCanvas()
        } else {
          this._retry = (this._retry || 0) + 1
          if (this._retry < 60) {
            setTimeout(() => this.scheduleInit(), 50)
          }
        }
      },
      initCanvas () {
        const container = this.$refs.flowContainer
        if (!container) {
          return
        }
        this.lf = new LogicFlow({
          container: container,
          grid: true,
          keyboard: { enabled: true },
          multipleSelectKey: 'ctrl',
          isSilentMode: false
        })
        this.registerNodes()
        this.lf.openSelectionSelect()
        this.lf.on('node:click', ({ data }) => this.selectNode(data))
        this.lf.on('edge:click', ({ data }) => this.selectEdge(data))
        this.lf.on('blank:click', () => { this.currentEdit = null })
        this.renderGraph()
      },
      renderGraph () {
        this.lf.render(this.form.formJson ? this.fromFormJson(this.form.formJson) : {})
      },
      registerNodes () {
        this.lf.register({ type: 'start', view: StartView, model: StartModel })
        this.lf.register({ type: 'end', view: EndView, model: EndModel })
        this.lf.register({ type: 'approval', view: ApprovalView, model: ApprovalModel })
        this.lf.register({ type: 'cc', view: CcView, model: CcModel })
        this.lf.register({ type: 'condition', view: ConditionView, model: ConditionModel })
      },
      fromFormJson (formJson) {
        const obj = typeof formJson === 'string' ? JSON.parse(formJson) : formJson
        const nodes = (obj && obj.nodes ? obj.nodes : []).map((n, i) => ({
          id: n.id,
          type: n.type,
          x: n.x || 340,
          y: n.y || (80 + i * 90),
          text: { value: n.text || '', x: n.x || 340, y: (n.y || (80 + i * 90)) - 20 },
          properties: {
            assigneeType: (n.properties && n.properties.assigneeType) || 'fixed_user',
            assigneeIds: (n.properties && n.properties.assigneeIds) || '',
            approveType: (n.properties && n.properties.approveType) || 'or_sign'
          }
        }))
        const edges = (obj && obj.edges ? obj.edges : []).map(e => ({
          type: 'polyline',
          sourceNodeId: e.source,
          targetNodeId: e.target,
          properties: { condition: e.condition || '' }
        }))
        return { nodes: nodes, edges: edges }
      },
      buildFormJson () {
        const graphData = this.lf.getGraphData()
        const nodes = (graphData.nodes || []).map(n => {
          const text = typeof n.text === 'string' ? n.text : (n.text && n.text.value ? n.text.value : '')
          return {
            id: n.id,
            type: n.type,
            x: n.x,
            y: n.y,
            text: text,
            properties: {
              assigneeType: (n.properties && n.properties.assigneeType) || 'fixed_user',
              assigneeIds: (n.properties && n.properties.assigneeIds) || '',
              approveType: (n.properties && n.properties.approveType) || 'or_sign'
            }
          }
        })
        const edges = (graphData.edges || []).map(e => ({
          source: e.sourceNodeId,
          target: e.targetNodeId,
          condition: (e.properties && e.properties.condition) || ''
        }))
        return JSON.stringify({ nodes: nodes, edges: edges })
      },
      addNode (type) {
        if (!this.lf) {
          return
        }
        this.lf.addNode({
          type: type,
          x: 120 + Math.round(Math.random() * 200),
          y: 120 + Math.round(Math.random() * 180),
          text: DEFAULT_TEXT[type] || '节点',
          properties: {
            assigneeType: 'fixed_user',
            assigneeIds: '',
            approveType: 'or_sign'
          }
        })
      },
      startDrag (type, e) {
        if (!this.lf) {
          return
        }
        if (e) {
          e.preventDefault()
          e.stopPropagation()
        }
        this.lf.dnd.startDrag({
          type: type,
          text: DEFAULT_TEXT[type] || '节点',
          properties: {
            assigneeType: 'fixed_user',
            assigneeIds: '',
            approveType: 'or_sign'
          }
        })
      },
      selectNode (data) {
        const bizType = data.type
        const text = typeof data.text === 'string' ? data.text : (data.text && data.text.value ? data.text.value : '')
        this.currentEdit = { kind: 'node', id: data.id, bizType: bizType }
        this.editForm = {
          text: text,
          assigneeType: (data.properties && data.properties.assigneeType) || 'fixed_user',
          assigneeIds: (data.properties && data.properties.assigneeIds) || '',
          roleId: undefined,
          approveType: (data.properties && data.properties.approveType) || 'or_sign',
          condition: ''
        }
        const ids = this.editForm.assigneeIds ? this.editForm.assigneeIds.split(',') : []
        this.assigneeIdArr = ids
        if (this.editForm.assigneeType === 'role' && ids.length > 0) {
          this.editForm.roleId = ids[0]
        }
        // 条件节点：读取出边摘要
        this.conditionEdges = []
        if (bizType === 'condition' && this.lf) {
          const outgoing = this.lf.getNodeOutgoingEdge(data.id) || []
          this.conditionEdges = outgoing.map(e => {
            const cond = (e.properties && e.properties.condition) || (e.getProperties && e.getProperties().condition) || ''
            return { id: e.id, text: cond ? cond : '默认分支' }
          })
        }
      },
      selectEdge (data) {
        this.currentEdit = { kind: 'edge', id: data.id }
        const raw = (data.properties && data.properties.condition) || ''
        this.editForm = {
          text: '',
          assigneeType: 'fixed_user',
          assigneeIds: '',
          roleId: undefined,
          approveType: 'or_sign',
          conditionOp: 'AND',
          isDefaultBranch: false,
          conditionList: []
        }
        if (!raw) {
          this.editForm.isDefaultBranch = true
        } else {
          try {
            const tree = JSON.parse(raw)
            if (tree && tree.conditions) {
              this.editForm.conditionOp = tree.op === 'OR' ? 'OR' : 'AND'
              this.editForm.conditionList = (tree.conditions || []).map(c => ({
                field: c.field || '',
                operator: c.operator || '>',
                value: (c.value !== undefined && c.value !== null) ? String(c.value) : ''
              }))
            } else {
              this.editForm.conditionList = [{ field: '', operator: '>', value: '' }]
            }
          } catch (e) {
            this.editForm.conditionList = [{ field: '', operator: '>', value: '' }]
          }
        }
      },
      applyNode () {
        if (!this.currentEdit || !this.lf) {
          return
        }
        let assigneeIds = ''
        if (this.editForm.assigneeType === 'fixed_user') {
          assigneeIds = this.assigneeIdArr.join(',')
        } else if (this.editForm.assigneeType === 'role') {
          assigneeIds = this.editForm.roleId ? String(this.editForm.roleId) : ''
        } else if (this.editForm.assigneeType === 'field_var') {
          assigneeIds = this.editForm.assigneeIds
        } else {
          assigneeIds = ''
        }
        this.lf.updateText(this.currentEdit.id, this.editForm.text)
        this.lf.setProperties(this.currentEdit.id, {
          assigneeType: this.editForm.assigneeType,
          assigneeIds: assigneeIds,
          approveType: this.editForm.approveType
        })
        this.$message.success('已应用')
      },
      applyEdge () {
        if (!this.currentEdit || !this.lf) {
          return
        }
        let condition = ''
        if (!this.editForm.isDefaultBranch) {
          const list = (this.editForm.conditionList || []).filter(c => c && c.field && (c.value !== '' && c.value !== undefined && c.value !== null))
          if (list.length > 0) {
            condition = JSON.stringify({ op: this.editForm.conditionOp || 'AND', conditions: list })
          }
        }
        this.lf.setProperties(this.currentEdit.id, { condition: condition })
        this.$message.success('已应用')
      },
      addCondition () {
        this.editForm.conditionList.push({ field: '', operator: '>', value: '' })
      },
      removeCondition (idx) {
        this.editForm.conditionList.splice(idx, 1)
      },
      deleteCurrent () {
        if (!this.currentEdit || !this.lf) {
          return
        }
        if (this.currentEdit.kind === 'node') {
          this.lf.deleteNode(this.currentEdit.id)
        } else {
          this.lf.deleteEdge(this.currentEdit.id)
        }
        this.currentEdit = null
      },
      deleteSelected () {
        if (!this.lf) {
          return
        }
        const selected = this.lf.getSelectElements(true) || {}
        const nodes = selected.nodes || []
        const edges = selected.edges || []
        if (nodes.length === 0 && edges.length === 0) {
          this.$message.warning('请先框选或按住 Ctrl 多选要删除的节点/连线')
          return
        }
        edges.forEach(e => this.lf.deleteEdge(e.id))
        nodes.forEach(n => this.lf.deleteNode(n.id))
        this.currentEdit = null
      },
      undo () {
        if (this.lf) {
          this.lf.undo()
        }
      },
      redo () {
        if (this.lf) {
          this.lf.redo()
        }
      },
      zoomIn () {
        if (this.lf) {
          this.lf.zoom(true)
        }
      },
      zoomOut () {
        if (this.lf) {
          this.lf.zoom(false)
        }
      },
      fitView () {
        if (this.lf) {
          this.lf.fitView()
        }
      },
      showJsonModal () {
        if (!this.lf) {
          return
        }
        const formJson = this.buildFormJson()
        try {
          this.jsonText = JSON.stringify(JSON.parse(formJson), null, 2)
        } catch (e) {
          this.jsonText = formJson
        }
        this.jsonModalVisible = true
      },
      formatJson () {
        try {
          this.jsonText = JSON.stringify(JSON.parse(this.jsonText), null, 2)
        } catch (e) {
          this.$message.error('JSON 格式错误')
        }
      },
      compressJson () {
        try {
          this.jsonText = JSON.stringify(JSON.parse(this.jsonText))
        } catch (e) {
          this.$message.error('JSON 格式错误')
        }
      },
      copyJson () {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(this.jsonText).then(() => this.$message.success('已复制')).catch(() => this.$message.error('复制失败'))
        } else {
          this.$message.error('当前浏览器不支持复制，请手动选择复制')
        }
      },
      applyJson () {
        try {
          const obj = JSON.parse(this.jsonText)
          if (!obj || !Array.isArray(obj.nodes) || obj.nodes.length === 0) {
            this.$message.error('JSON 缺少 nodes 节点')
            return
          }
          this.form.formJson = JSON.stringify(obj)
          if (this.lf) {
            this.lf.render(this.fromFormJson(this.form.formJson))
          }
          this.jsonModalVisible = false
          this.$message.success('已应用到画布')
        } catch (e) {
          this.$message.error('JSON 格式错误')
        }
      },
      handleSave () {
        if (!this.form.flowName) {
          this.$message.warning('请输入流程名称')
          return
        }
        if (!this.form.billType) {
          this.$message.warning('请选择单据类型')
          return
        }
        if (!this.lf) {
          this.$message.warning('画布未初始化')
          return
        }
        const graphData = this.lf.getGraphData()
        const hasStart = (graphData.nodes || []).some(n => n.type === 'start')
        const hasEnd = (graphData.nodes || []).some(n => n.type === 'end')
        const hasApproval = (graphData.nodes || []).some(n => n.type === 'approval')
        if (!hasStart || !hasEnd) {
          this.$message.warning('流程需包含发起人和结束节点')
          return
        }
        if (!hasApproval) {
          this.$message.warning('请至少添加一个审批节点')
          return
        }
        const saveId = this.isDefaultFlow ? null : this.form.id
        this.saving = true
        flowDefineSave({
          id: saveId,
          flowName: this.form.flowName,
          billType: this.form.billType,
          flowCode: this.form.flowCode,
          formJson: this.buildFormJson()
        }).then((res) => {
          if (res && res.code === 200) {
            this.$message.success('保存成功')
            this.$emit('saved')
          } else {
            this.$message.warning(res.data && res.data.message ? res.data.message : '保存失败')
          }
        }).finally(() => {
          this.saving = false
        })
      },
      handleBack () {
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>
  .flow-design-form {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .flow-toolbar {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  .flow-designer {
    display: flex;
    align-items: stretch;
  }
  .node-panel {
    width: 110px;
    flex-shrink: 0;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 8px;
    margin-right: 8px;
  }
  .node-panel .panel-title,
  .prop-panel .panel-title {
    font-weight: bold;
    margin-bottom: 8px;
    color: rgba(0, 0, 0, 0.85);
  }
  .node-item {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    padding: 6px 8px;
    margin-bottom: 8px;
    cursor: pointer;
    text-align: center;
    background: #fff;
    font-size: 13px;
  }
  .node-item:hover {
    border-color: #1890ff;
    color: #1890ff;
  }
  .flow-canvas {
    flex: 1;
    min-width: 500px;
    height: calc(100vh - 180px);
    border: 1px solid #e8e8e8;
    border-radius: 4px;
  }
  .prop-panel {
    width: 280px;
    flex-shrink: 0;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 10px;
    margin-left: 8px;
    overflow-y: auto;
  }
  .panel-tip {
    color: rgba(0, 0, 0, 0.45);
    font-size: 13px;
    padding: 20px 0;
  }
</style>